// extracted by mini-css-extract-plugin
module.exports = {"page":"RatesPage_page__2wRv5"};